export default {
  sections: {
    address: "Adresse de l'entreprise",
    address_help:
      "Saisissez l'adresse à laquelle votre entreprise est enregistrée. Elle est imprimée sur vos factures.",
  },
  form: {
    legal_form: {
      label: "Type d'entreprise",
      help: 'Une UG (haftungsbeschränkt) correspond ici à une GmbH, une e.K. à une entreprise individuelle. Pour une OHG ou une KG, veuillez contacter le support.',
      options: {
        sole_trader: 'Entreprise individuelle',
        gbr: 'GbR',
        gmbh: 'GmbH / UG',
      },
    },
    legal_name: {
      label: 'Raison sociale enregistrée',
      placeholder: 'Saisissez la raison sociale enregistrée',
      sole_trader_help: 'Laisser vide si vous exercez sous votre propre nom',
    },
  },
  buttons: {
    next: 'Suivant',
  },
};
